<template>
	<el-image
		v-loading="loading"
		v-if="props.pic != null && props.pic != ''"
		:src="props.pic"
		:zoom-rate="1.2"
		:max-scale="7"
		:min-scale="0.2"
		:preview-teleported="true"
		:preview-src-list="[props.pic]"
		fit="cover"
	/>
	<el-empty v-else v-loading="loading" description="暂无图片" :image-size="50"></el-empty>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
const props = defineProps({
	pic: {
		type: String,
		default: ''
	}
})
const loading = ref(true)
onMounted(() => {
	loading.value = false
})

onUnmounted(() => {})
</script>

<style scoped>
.el-image {
	width: 80px;
	height: 80px;
	border-radius: 5px;
	overflow: hidden;
}
.el-empty {
	width: 80px;
	height: 86px;
	border-radius: 5px;
}
:deep(.el-empty__description) {
	margin-top: 2px;
}
</style>
